import config from '../../config'

const authApi = `${config.apiHost}/oem-auth`

export default {
    init: {
        url: `${authApi}/admin/auth/init`,
        type: 'GET',
    },
    login: {
        url: `${authApi}/admin/auth/token`,
        type: 'POST',
    },
    logout: {
        url: `${authApi}/admin/auth/token`,
        type: 'DELETE',
    },
}
